<template>
  <div>
    <transition>
      <div class="outer" :style="styleObject" @click="onCancle">
        <div class="popup" :class="[show ? 'popup-active': 'popup-deactive']">
          <div class="confirm">
            <div class="title">
              {{title}}
            </div>
            <div class="confirm-btn" @click="onOk">
              {{okText}}
            </div>
          </div>
          <div class="cancle-btn" @click="onCancle">
            {{cancleText}}
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "xm-under-enter",
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    okText: {
      type: String,
      required: true
    },
    cancleText: {
      type: String,
      required: true
    },
    onOk: {
      type: Function,
      required: true
    },
    onCancle: {
      type: Function,
      required: true
    },
    overlay: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    styleObject: function() {
      return {
        display: this.show ? "block" : "none"
      };
    }
  },

  created() {
    window.addEventListener(
      "popstate",
      (e) =>{
         window.hideUnderEnter();
      },
      false
    );
  }
};
</script>

<style lang="less" scoped>
.outer {
  z-index: 9999;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  animation: deepen 0.2s ease-out;
  .popup {
    position: fixed;
    top: auto;
    bottom: 0;
    left: 50%;
    right: 50%;
    width: 100%;
    padding: 0.2rem;
    transform: translate3d(-50%, 0, 0);
    .confirm {
      width: 100%;
      background: #fff;
      border-radius: 0.2rem;
      margin-bottom: 0.2rem;
      .title {
        font-size: 0.26rem;
        color: #999;
        border-bottom: 0.02rem solid #dadada;
        padding: 0.1rem;
      }
      .confirm-btn {
        font-size: 0.4rem;
        color: #fe3824;
        padding: 0.25rem 0 0.2rem 0;
      }
    }
    .cancle-btn {
      width: 100%;
      background: #fff;
      border-radius: 0.2rem;
      font-size: 0.4rem;
      color: #0076ff;
      padding: 0.25rem 0 0.2rem 0;
    }
  }
  .popup-active {
    animation: popUp 0.4s ease-out;
  }

  @keyframes deepen {
    from {
      background: rgba(0, 0, 0, 0);
    }

    to {
      background: rgba(0, 0, 0, 0.5);
    }
  }
  @keyframes popUp {
    from {
      transform: translate3d(-50%, 100%, 0);
    }
    to {
      transform: translate3d(-50%, 0, 0);
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/UnderEnter.vue